/* PARALIA · sitio nuevo · encabezado (sections/pa-header.liquid).
   - Mueve los cajones (menú de celular y búsqueda) al final del body: el encabezado fijo crea su propio
     contexto de capas y los dejaría debajo del fondo oscuro.
   - Mega menú con pestañas: abre con hover, con clic y con teclado (flecha abajo, Escape).
   - Pestañas del menú de celular.
   - Búsqueda predictiva con /search/suggest.json; precios con PA.formatMoney. */
(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = pesos => {
    const cents = Math.round(parseFloat(pesos) * 100);
    if (window.PA && PA.formatMoney) return PA.formatMoney(cents);
    return '$' + (cents / 100).toLocaleString('en-US');
  };
  const sized = (url, w) => (url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : '');
  const ICON_SEARCH = '<svg class="pa-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="6.5"/><path d="m20 20-4.2-4.2"/></svg>';

  /* ---------- cajones al body ---------- */
  function portal(scope) {
    scope.querySelectorAll('[data-pa-hdr-portal]').forEach(el => {
      Array.from(document.body.children).forEach(old => { if (old !== el && old.id === el.id) old.remove(); });
      document.body.appendChild(el);
    });
  }

  /* ---------- mega menú ---------- */
  function initMega(header) {
    const mega = header.querySelector('[data-pa-mega]');
    if (!mega) return;
    const openers = Array.from(header.querySelectorAll('[data-pa-mega-open]'));
    const tabs = Array.from(mega.querySelectorAll('[data-pa-tab]'));
    const panels = Array.from(mega.querySelectorAll('[data-pa-tabpanel]'));
    const canHover = window.matchMedia('(hover: hover)');
    let timer = null;
    let current = null;
    let openedAt = 0;
    let lastOpener = null;

    const open = id => {
      clearTimeout(timer);
      if (current !== id) openedAt = Date.now();
      mega.hidden = false;
      tabs.forEach(t => t.setAttribute('aria-expanded', String(t.dataset.paTab === id)));
      panels.forEach(p => { p.hidden = p.dataset.paTabpanel !== id; });
      openers.forEach(o => o.setAttribute('aria-expanded', String(o.dataset.paMegaOpen === id)));
      current = id;
    };
    const close = () => {
      clearTimeout(timer);
      mega.hidden = true;
      openers.forEach(o => o.setAttribute('aria-expanded', 'false'));
      current = null;
    };
    const closeLater = () => { clearTimeout(timer); timer = setTimeout(close, 180); };

    openers.forEach(o => {
      const id = o.dataset.paMegaOpen;
      o.addEventListener('mouseenter', () => {
        if (!canHover.matches) return;
        clearTimeout(timer);
        timer = setTimeout(() => { lastOpener = o; open(id); }, 80);
      });
      o.addEventListener('click', () => {
        lastOpener = o;
        if (current === id) {
          if (canHover.matches && Date.now() - openedAt < 600) return; // recién abierto con hover
          close();
        } else {
          open(id);
        }
      });
      o.addEventListener('keydown', e => {
        if (e.key !== 'ArrowDown') return;
        e.preventDefault();
        lastOpener = o;
        open(id);
        const t = mega.querySelector(`[data-pa-tab="${id}"]`);
        if (t) t.focus();
      });
    });

    tabs.forEach(t => {
      const id = t.dataset.paTab;
      t.addEventListener('mouseenter', () => { if (canHover.matches) open(id); });
      t.addEventListener('focus', () => open(id));
      t.addEventListener('click', () => open(id));
    });

    const list = mega.querySelector('.pa-hdr-tabs');
    if (list) {
      list.addEventListener('keydown', e => {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        const items = Array.from(list.querySelectorAll('.pa-hdr-tab'));
        const i = items.indexOf(document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        const next = items[(i + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length];
        next.focus();
      });
    }

    /* Salir: del encabezado, al fondo oscuro, o a un enlace de la barra que no abre el mega menú. */
    header.addEventListener('mouseleave', () => { if (canHover.matches && current) closeLater(); });
    const panel = mega.querySelector('.pa-hdr-mega__panel');
    if (panel) panel.addEventListener('mouseenter', () => clearTimeout(timer));
    const dim = mega.querySelector('[data-pa-mega-dim]');
    if (dim) {
      dim.addEventListener('mouseenter', () => { if (canHover.matches) closeLater(); });
      dim.addEventListener('click', close);
    }
    header.querySelectorAll('.pa-hdr-inner a, .pa-hdr-inner button:not([data-pa-mega-open])').forEach(el => {
      el.addEventListener('mouseenter', () => { if (canHover.matches && current) closeLater(); });
    });

    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape' || !current) return;
      close();
      if (lastOpener) lastOpener.focus();
    });
    header.addEventListener('focusout', e => {
      if (current && e.relatedTarget && !header.contains(e.relatedTarget)) close();
    });
    document.addEventListener('click', e => { if (current && !header.contains(e.target)) close(); });
    document.addEventListener('pa:drawer:open', close);
  }

  /* ---------- pestañas del menú de celular ---------- */
  function initMobileTabs(menu) {
    const tabs = Array.from(menu.querySelectorAll('[data-pa-mtab]'));
    if (!tabs.length) return;
    const select = tab => {
      tabs.forEach(t => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const p = menu.querySelector(`[data-pa-mpanel="${t.dataset.paMtab}"]`);
        if (p) p.hidden = !on;
      });
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', e => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        select(next);
        next.focus();
      });
    });
  }

  /* ---------- búsqueda predictiva ---------- */
  function initSearch(drawer) {
    const input = drawer.querySelector('[data-pa-search-input]');
    if (!input) return;
    const form = input.form;
    const clearBtn = drawer.querySelector('[data-pa-search-clear]');
    const empty = drawer.querySelector('[data-pa-search-empty]');
    const res = drawer.querySelector('[data-pa-search-results]');
    const group = name => res.querySelector(`[data-pa-res="${name}"]`);
    const none = res.querySelector('[data-pa-res-none]');
    const alls = Array.from(res.querySelectorAll('[data-pa-search-all]'));
    const examples = (drawer.dataset.examples || '').split(',').map(s => s.trim()).filter(Boolean);
    const tpl = drawer.dataset.placeholder || '';
    const emptyTpl = drawer.dataset.emptyText || '';
    const searchUrl = q => `${root}search?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last`;
    let ctrl = null;
    let debounce = null;
    let rotate = null;
    let ex = 0;

    const highlight = (title, q) => {
      let html = esc(title);
      q.split(/\s+/).filter(w => w.length > 1).forEach(w => {
        const re = new RegExp('(' + esc(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
        html = html.replace(re, '<u>$1</u>');
      });
      return html;
    };
    /* styled_text trae <mark> en lo que coincide y <span> en lo demás: solo se conserva el <mark> (en negritas). */
    const decoder = document.createElement('textarea');
    const decode = t => { decoder.innerHTML = t; return decoder.value; };
    const styled = s => String(s).split(/(<\/?mark>)/).map(part => {
      if (part === '<mark>') return '<b>';
      if (part === '</mark>') return '</b>';
      return esc(decode(part.replace(/<[^>]*>/g, '')));
    }).join('');
    const price = p => {
      const cmp = parseFloat(p.compare_at_price_min || p.compare_at_price_max || 0);
      const now = parseFloat(p.price || p.price_min || 0);
      if (cmp > now) return `<span class="pa-price"><s class="pa-price__compare">${money(cmp)}</s><span class="pa-price__sale">${money(now)}</span></span>`;
      return `<span class="pa-price"><span class="pa-price__regular">${money(now)}</span></span>`;
    };
    const img = (src, w, alt) => (src ? `<img src="${esc(sized(src, w))}" srcset="${esc(sized(src, w))} 1x, ${esc(sized(src, w * 2))} 2x" alt="${esc(alt || '')}" loading="lazy">` : '');

    const fill = (name, items) => {
      const g = group(name);
      if (!g) return;
      g.querySelector('[data-pa-res-list]').innerHTML = items.join('');
      g.hidden = items.length === 0;
    };

    const render = (q, r) => {
      const queries = (r.queries || []).slice(0, 3).map(s => `<li><a class="pa-hdr-s-sug" href="${esc(searchUrl(s.text))}">${ICON_SEARCH}<span>${styled(s.styled_text || s.text)}</span></a></li>`);
      const products = (r.products || []).slice(0, 3).map(p => {
        const src = (p.featured_image && p.featured_image.url) || p.image;
        return `<li><a class="pa-hdr-s-prod" href="${esc(p.url)}"><span class="pa-hdr-s-prod__media">${img(src, 400, p.title)}</span><span class="pa-hdr-s-prod__body"><span class="pa-hdr-s-prod__name">${highlight(p.title, q)}</span>${price(p)}</span></a></li>`;
      });
      const collections = (r.collections || []).slice(0, 3).map(c => {
        const src = c.featured_image && c.featured_image.url;
        return `<li><a class="pa-hdr-s-col" href="${esc(c.url)}"><span class="pa-hdr-thumb">${img(src, 120, '')}</span><span>${esc(c.title)}</span></a></li>`;
      });
      fill('queries', queries);
      fill('products', products);
      fill('collections', collections);
      const nothing = !queries.length && !products.length && !collections.length;
      none.hidden = !nothing;
      none.textContent = nothing ? emptyTpl.replace('[busqueda]', q) : '';
      alls.forEach(a => { a.href = searchUrl(q); a.hidden = nothing; });
      empty.hidden = true;
      res.hidden = false;
    };

    const run = async q => {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=3&resources[limit_scope]=each&resources[options][unavailable_products]=last`;
      try {
        const r = await fetch(url, { signal: ctrl.signal, headers: { Accept: 'application/json' } });
        const data = await r.json();
        if (input.value.trim() !== q) return;
        render(q, (data.resources && data.resources.results) || {});
      } catch (err) {
        if (err.name === 'AbortError') return;
        render(q, {});
      }
    };

    const onInput = () => {
      const q = input.value.trim();
      const has = input.value.length > 0;
      if (clearBtn) clearBtn.hidden = !has;
      form.classList.toggle('has-value', has);
      clearTimeout(debounce);
      if (!q) {
        if (ctrl) ctrl.abort();
        res.hidden = true;
        empty.hidden = false;
        return;
      }
      debounce = setTimeout(() => run(q), 180);
    };
    input.addEventListener('input', onInput);

    if (clearBtn) clearBtn.addEventListener('click', () => { input.value = ''; onInput(); input.focus(); });

    drawer.addEventListener('click', e => {
      const term = e.target.closest('[data-pa-search-term]');
      if (!term) return;
      e.preventDefault();
      input.value = term.dataset.paSearchTerm;
      onInput();
      input.focus();
    });

    /* El ejemplo del campo vacío cambia solo mientras el cajón está abierto. */
    const setPlaceholder = () => { if (examples.length && tpl) input.placeholder = tpl.replace('[ejemplo]', examples[ex % examples.length]); };
    document.addEventListener('pa:drawer:open', e => {
      if (e.detail.id !== drawer.id) return;
      clearInterval(rotate);
      if (examples.length > 1) rotate = setInterval(() => { if (!input.value) { ex += 1; setPlaceholder(); } }, 2800);
    });
    document.addEventListener('pa:drawer:close', e => {
      if (e.detail.id !== drawer.id) return;
      clearInterval(rotate);
      ex = 0;
      setPlaceholder();
    });
  }

  function init(scope) {
    const header = scope.querySelector('[data-pa-header]');
    if (!header) return;
    const menu = header.querySelector('#PaMenuDrawer');
    const search = header.querySelector('#PaSearchDrawer');
    portal(header);
    initMega(header);
    if (menu) initMobileTabs(menu);
    if (search) initSearch(search);
  }

  const start = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', e => { if (e.target && e.target.querySelector('[data-pa-header]')) init(e.target); });
})();
